import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/baseUi/tabs"
import { cn } from "@/modules/lib/utils"
import { BoxLeadOffersList } from "@modules/boxLead/components/boxLeadInfo/boxLeadOffersList"
import { BoxOfferInvitationStatus } from "@modules/boxOffer/entities/boxOfferTypes"
import { useBoxOfferInvitations } from "@modules/boxOffer/hooks/useBoxOffer"
import { word } from "@modules/core/utils/i18n"
import { startTransition, useMemo, useState } from "react"

type Props = {
  userId: string
  className?: string
} & React.ComponentProps<"div">

export function BoxLeadOffersWrapper({ userId, className, ...props }: Props) {
  const emptyText = {
    active: word("box.members.tab.offer.emptyText.noActive"),
    pending: word("box.members.tab.offer.emptyText.noPending"),
    expired: word("box.members.tab.offer.emptyText.noExpired"),
  }
  const { data: dataInvitations } = useBoxOfferInvitations(userId)
  const [activeMembershipsIndex, setActiveMembershipsIndex] = useState("0")

  const pendingInvitations = useMemo(
    () => dataInvitations.filter((invitation) => invitation.status === BoxOfferInvitationStatus.PENDING),
    [dataInvitations],
  )
  const expiredInvitations = useMemo(
    () =>
      dataInvitations.filter((invitation) =>
        [BoxOfferInvitationStatus.REFUSED, BoxOfferInvitationStatus.CANCELLED].includes(invitation.status),
      ),
    [dataInvitations],
  )

  function selectTab(index: string) {
    startTransition(() => {
      setActiveMembershipsIndex(index)
    })
  }

  return (
    <div className={cn("flex w-full flex-col gap-4", className)} {...props}>
      <Tabs defaultValue={activeMembershipsIndex}>
        <TabsList variant="roundedButton">
          <TabsTrigger variant="roundedButton" onClick={() => selectTab("0")} value="0">
            {word("box.members.tab.offer.menu.pending")} ({pendingInvitations.length})
          </TabsTrigger>
          <TabsTrigger variant="roundedButton" onClick={() => selectTab("1")} value="1">
            {word("box.members.tab.offer.menu.expiredAndDeclined")} ({expiredInvitations.length})
          </TabsTrigger>
        </TabsList>
        <TabsContent value="0" className="flex w-full">
          <BoxLeadOffersList boxOfferInvitations={pendingInvitations} emptyText={emptyText.pending} />
        </TabsContent>
        <TabsContent value="1" className="flex w-full">
          <BoxLeadOffersList boxOfferInvitations={expiredInvitations} emptyText={emptyText.expired} />
        </TabsContent>
      </Tabs>
    </div>
  )
}
